module.exports = __webpack_public_path__ + "img/link-broken-01.a058d785.svg";